var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "change-order-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("Message.Prompt"),
            width: "340px",
            "close-on-click-modal": false,
            "show-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: _vm.cancel
          }
        },
        [
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.jobNo,
                          expression: "form.jobNo"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.BusinessNo") + "：" }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.form.jobNo))])]
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.mbl,
                          expression: "form.mbl"
                        }
                      ],
                      attrs: { label: "MBL NO：" }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.form.mbl))])]
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.hbl,
                          expression: "form.hbl"
                        }
                      ],
                      attrs: { label: "HBL NO：" }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.form.hbl))])]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.tip,
                          expression: "form.tip"
                        }
                      ]
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.tip.customerCompanyName,
                              expression: "form.tip.customerCompanyName"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_Parter") + "："
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.form.tip.customerCompanyName || "")
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.tip.customerOverCreditLimitAmount,
                              expression:
                                "form.tip.customerOverCreditLimitAmount"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CreditLine") + "："
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_ExceededAmount", [
                                  _vm.form.tip.customerOverCreditLimitAmount
                                ])
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.tip.customerOverCreditLimitDate,
                              expression: "form.tip.customerOverCreditLimitDate"
                            }
                          ],
                          attrs: {
                            label:
                              _vm.$t("CargoMsg.Cargo_CreditAccountingPeriod") +
                              "："
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Exceeded")))
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.tip.agentCompanyName,
                              expression: "form.tip.agentCompanyName"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_Parter") + "："
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.form.tip.agentCompanyName || ""))
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.tip.agentOverCreditLimitAmount,
                              expression: "form.tip.agentOverCreditLimitAmount"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CreditLine") + "："
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_ExceededAmount", [
                                  _vm.form.tip.agentOverCreditLimitAmount
                                ])
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.tip.agentOverCreditLimitDate,
                              expression: "form.tip.agentOverCreditLimitDate"
                            }
                          ],
                          attrs: {
                            label:
                              _vm.$t("CargoMsg.Cargo_CreditAccountingPeriod") +
                              "："
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Exceeded")))
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.tip.accountCompanyName,
                              expression: "form.tip.accountCompanyName"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_Parter") + "："
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.form.tip.accountCompanyName || "")
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.tip.accountOverCreditLimitAmount,
                              expression:
                                "form.tip.accountOverCreditLimitAmount"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CreditLine") + "："
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_ExceededAmount", [
                                  _vm.form.tip.accountOverCreditLimitAmount
                                ])
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.tip.accountOverCreditLimitDate,
                              expression: "form.tip.accountOverCreditLimitDate"
                            }
                          ],
                          attrs: {
                            label:
                              _vm.$t("CargoMsg.Cargo_CreditAccountingPeriod") +
                              "："
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Exceeded")))
                          ])
                        ]
                      ),
                      !_vm.isReleasing
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "ReleaseNotes.lineCreditDialog.triggerRemind"
                                )
                              )
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_ContinueToReleaseDocuments"
                                )
                              )
                            )
                          ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right", "margin-top": "20px" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.index > 0,
                          expression: "index > 0"
                        }
                      ],
                      attrs: { no: "Previous", type: "primary" },
                      on: { click: _vm.lastHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Previous")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.index < _vm.releaseRules.length - 1,
                          expression: "index < releaseRules.length - 1"
                        }
                      ],
                      attrs: { no: "NextItem", type: "primary" },
                      on: { click: _vm.nextHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NextItem")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isReleasing,
                          expression: "isReleasing"
                        }
                      ],
                      attrs: { no: "confirm" },
                      on: { click: _vm.confirm }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { no: "cancel" }, on: { click: _vm.cancel } },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }